import React from 'react';
import { Col } from 'react-bootstrap';

export const ProjectItem = ({ image, link }) => (
	<Col className="project-item" md={6} sm={6} xs={12}>
		<div className="inner-box">
			<figure className="image-box">
				<a href={link}>
					<img
						src={image}
						alt={image} />
				</a>
			</figure>
		</div>
	</Col>
);



// WEBPACK FOOTER //
// ./src/components/ui/Projects/ProjectItem.js